import { render, staticRenderFns } from "./CheckboxExpansionPanel.vue?vue&type=template&id=c863f8e4&scoped=true&"
import script from "./CheckboxExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./CheckboxExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxExpansionPanel.vue?vue&type=style&index=0&id=c863f8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c863f8e4",
  null
  
)

export default component.exports